// console.log('custom.js');
$(function () {
  /*
  共通ヘッダー
  スクロールで、PCはメニュー表示(.js-topmenu)・SPはヘッダー縮小(.js-header)
  */
  $(window).scroll(function(){
    scroll = $(this).scrollTop();
    winW = $(window).width();
    if(winW > 960){
      target = $('.js-topmenu');
    }else{
      target = $('.js-header');
    }
    if(scroll >= 10){
      target.addClass('is-scroll');
    }else{
      target.removeClass('is-scroll');
    }
  });

  /*
  検索: クリアボタン
  */
  $('.js-search-clear').click(function(){
    $('.js-search-input').val('');
    $('.js-search-clear').fadeOut(300);
  });
  $('.js-search-input').on('keyup', function() {
    showClearBtn($(this));
    copyInputVal($(this));
  });
  $('.js-search-input').on('change', function() {
    showClearBtn($(this));
    copyInputVal($(this));
  });
  function showClearBtn($this){
    val = $this.val();
    if(val != ''){
      $this.next('.js-search-clear').fadeIn(300);
    }else{
      $this.next('.js-search-clear').fadeOut(300);
    }
  }
  //SP:ヘッダー内検索・ドロワー内検索に入力内容をセット
  function copyInputVal($this){ 
    val = $this.val();
    $('.js-search-input').val(val);
  }

  /*
  人気キーワード (PC:クイックサーチ)
  検索ボックス入力中はクイック検索結果が表示されるため、人気キーワードは非表示とする。
  */
  var $keywordslist = $('.quick-search .js-keywordslist');
  $('input.quick-search__input').keyup(function(){ //検索ボックス入力時
    if($('.quick-search__bar-inner').hasClass('active')){ //入力時にactiveクラスがついたら非表示
      $keywordslist.css('display','none');
    }else{
      $keywordslist.css('display','block');
    }
  });

  /*
  商品:SKUカート
  */
  // 開閉
  var skucart_scrollY = 0;
  $(document).on('click', '.js-skucart-open', function () {
    type = $(this).attr('data-type');
    target = $(this).parent('div').children('.js-skucart-wrap');
    skucart_scrollY = window.scrollY;
    // target.fadeIn(100);
    $('body').addClass('is-skucart-open');
    target.addClass('is-show');
    target.attr('data-type', type);
  }),
  $(document).on('click', '.js-skucart-close', function () {
    // $('body').removeClass('is-skucart-open');
    // $('html,body').scrollTop(skucart_scrollY);
    // $('.js-skucart-wrap').css('display', 'none');
    $('body').removeClass('is-skucart-open');
    $('html,body').scrollTop(skucart_scrollY);
    $('.js-skucart-wrap').removeClass('is-show');
  });

  // カート追加
  $('.js-skucart-addcart').on('click', function(){
    var formData = {
      'items': [{
      'id': $(this).data('variant-id'),
      'quantity': 1
      }]
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      console.log('商品が追加されました:', data);
      return fetch('/cart.js');
    })
    .then(response => response.json())
    .then(cartData => {
      console.log('現在のカート情報:', cartData);
      console.log('現在のカート件数:', cartData.item_count);
      window.location.href = "/cart";
    })
    .catch(error => {
      console.error('エラー:', error);
    });
  });

  /*
  SP:下部固定メニュー 探す
  */
  $('.js-btmmenu-search').click(function(){
    $(this).toggleClass('is-open');
    $('.js-menudrawer').toggleClass('is-open');
    $('html,body').toggleClass('is-menudrawer-open');
    $('.js-header').toggleClass('is-menudrawer-open');
    if($(this).hasClass('is-open')){
      $('.js-btmmenu-search ._label').html('閉じる');
    }else{
      $('.js-btmmenu-search ._label').html('探す');
    }
  });
  /*
  SP:下部固定メニュー キーワード検索
  */
  $('.js-menudrawer-form').click(function(){
    $('.js-searchdrawer').addClass('is-open');
    $('.js-searchdrawer .js-search-input').focus();
  });
  $('.js-searchdrawer-close').click(function(){
    $('.js-searchdrawer').removeClass('is-open');
  });
  /*
  SP:下部固定メニュー お気に入りアイコン class付与
  */
  var interval = setInterval(() => {
    var badge = $('.js-btmmenu-wishlist .topbadge');
    if (badge.length > 0) {
      var badgeText = badge.text().trim();
      if(badgeText != ''){
        $('.js-btmmenu-wishlist ._icon').addClass('is-active');
      }
      clearInterval(interval);
    }
  }, 100);
  /*
  SP:下部固定メニュー 検索履歴
  */
  var cookie_name = 'searchHistory';
  var max_history = 4;
  displayHistory();
  // Enterキー押下
  $('.js-search-input').on('keypress', function(e) {
    if (e.which === 13) {
      var searchWord = $(this).val().trim();
      if (searchWord) {
        saveHistory(searchWord);
      }
    }
  });
  // 履歴保存
  function saveHistory(searchWord) {
    var history = $.cookie(cookie_name) ? JSON.parse($.cookie(cookie_name)) : [];
    history = history.filter(word => word !== searchWord); //重複削除
    history.unshift(searchWord); //追加
    if (history.length > max_history) { //件数チェック・削除
      history.pop();
    }
    $.cookie(cookie_name, JSON.stringify(history), { expires: 7, path: '/' }); //保存
  }
  // 履歴表示
  function displayHistory() {
    var history = $.cookie(cookie_name) ? JSON.parse($.cookie(cookie_name)) : [];
    var historyList = $('.js-search-historylist');
    historyList.empty();
    if(history.length > 0){
      history.forEach(word => {
        tag = '';
        tag += '<li>';
        tag += `<a href="/search?q=${word}&type=product&options%5Bprefix%5D=last">`;
        tag += '<span class="_icon"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.165 18.808a8.745 8.745 0 1 0 0-17.49 8.745 8.745 0 0 0 0 17.49z" stroke="currentColor" stroke-width="1.6" stroke-miterlimit="10" stroke-linecap="round"></path><path d="m16.5 16.5 5.363 5.362" stroke="currentColor" stroke-width="1.6" stroke-miterlimit="10"></path></svg></span>';
        tag += word;
        tag += '</a>';
        tag += '</li>';
        historyList.append(tag);
      });
    }else{
      $('.js-search-history').css('display', 'none');
    }
  }

});
